module.exports = __webpack_public_path__ + "img/Badge_verif.d9003677.svg";